<template>
  <div id="survey-subview">
    <b-container v-if="!answerFromLinkPending" class="pb-5">
      <!-- START CONVERSATION -->
      <transition name="question-slide">
        <b-row align-v="center" align-h="center" v-if="showHello">
          <b-col cols="12" md="8" lg="6" >

            <div class="bubble--info" v-if="showValidationPrompt">
              <div class="message" v-html="$t('journey:pending-validation__body', { userEmail: user.email })"></div>
            </div>

            <div class="bubble">
              <div class="message" v-if="answerFromLinkSuccess">
                {{$t('personal:answer-from-link-success', { userName: user.name } )}}
              </div>
              <div class="message" v-else-if="user.name">
                {{$t('personal:basic-hello', { userName: user.name } )}}
              </div>
            </div>

            <div class="bubble--multiple-choice" v-if="showInvitationPrompt">
              <div class="message" v-html="$t('journey:invitation-prompt__title')"></div>
              <div class="message" v-html="$t('journey:invitation-prompt__body', { accountName: $store.state.account.name})"></div>
              <div id="trybutton" class="choices">
                <b-button to="/account/people">{{$t('journey:invitation-prompt__cta')}}</b-button>
                <b-button @click="skipOnboardingWrite">{{$t('journey:skip-invitation')}}</b-button>
              </div>
            </div>

          </b-col>
        </b-row>
      </transition>

      <!-- ASK TO COMPLETE SURVEY IF NEEDED -->
      <transition name="question-slide">
        <b-row align-v="center" align-h="center" v-if="showRemaining && !accountOnboarding">
          <b-col cols="12" md="8" lg="6" >

              <div class="bubble--multiple-choice" v-if="$store.state.pendingQuestions && $store.state.pendingQuestions.length > 0">
                <div class="message" v-if="$store.state.pendingQuestions.length > 1">
                  {{$t('personal:pending-questions-prompt', { questionCount: $store.state.pendingQuestions.length })}}
                  {{$t('personal:come-back')}}
                </div>
                <div class="message" v-if="$store.state.pendingQuestions.length == 1">
                  {{$t('personal:pending-one-question-prompt')}}
                  {{$t('personal:come-back')}}
                </div>
                <div id="answerbutton" class="choices">
                  <b-button @click="startSurvey()" :class="{ 'active': answerNowActive}" :disabled="answerNowActive">{{$t('personal:pending-questions-cta')}}</b-button>
                  <b-button v-if="currentEngagementReport.updatedAt" to="/personal/results" :disabled="answerNowActive">{{$t('personal:results-cta')}}</b-button>
                  <b-button v-if="currentCompanyEngagementReport.updatedAt" to="/team/reports" :disabled="answerNowActive">{{$t('personal:team-results-cta')}}</b-button>
                </div>
              </div>

          </b-col>
        </b-row>
      </transition>

      <!-- SURVEY QUESTIONS -->
      <div v-if="showQuestions">
        <b-row align-v="center" align-h="center" :id="'q-'+index" v-for="(pendingQuestion, index) in pendingQuestionsUpToIndex" v-bind:key="pendingQuestion._id">
          <b-col cols="12" md="8" lg="6" >
            <div class="bubble mt-3" v-if="pendingQuestion.opener && (index === 0 || renderOpener($store.state.pendingQuestions[index-1]) != renderOpener(pendingQuestion))">
              <div class="message opener">{{renderOpener(pendingQuestion)}}</div>
            </div>
            <transition name="question-slide" appear>
              <div class="bubble--multiple-choice">
                <div class="message"><i>{{renderQuesstion(pendingQuestion)}}</i></div>
                <div id="chooseanswerbutton" class="choices choicebuttons" v-if="pendingQuestion.type === 'multiple-choice'">
                  <b-button :class="{'active': answering[pendingQuestion.identifier] === option.value}" :disabled="answering[pendingQuestion.identifier] !== undefined" variant="survey" @click="answer(pendingQuestion.scaleIdentifier, pendingQuestion.identifier, option.value)" v-for="option in sortedOptions(pendingQuestion)" v-bind:key="option.value">{{i18nLabel(option)}}</b-button>
                </div>
                <div id="chooseanswerbutton" class="choices choicebuttons" v-if="pendingQuestion.type === 'open'">
                  <div v-if="openAnswer === null && answering[pendingQuestion.identifier] === undefined">
                    <b-button @click="openAnswer = ''; $forceUpdate(); $nextTick(() => { $el.querySelector('#openanswer').focus(); $scrollTo($el.querySelector('#feedbackButton'), 300) } )">Anna avointa palautetta</b-button>
                    <b-button @click="openAnswer = ''; answerOpen(pendingQuestion.scaleIdentifier, pendingQuestion.identifier, openAnswer)">Ohita</b-button>
                  </div>
                  <div v-if="openAnswer !== null && answering[pendingQuestion.identifier] === undefined">
                    <b-form-textarea
                      class="mb-3"
                      id="openanswer"
                      v-model="openAnswer"
                      rows="3"
                      max-rows="6"
                      placeholder="Kirjoita avoin palautteesi tähän ..."
                      ref="openAnswer"
                    ></b-form-textarea>
                    <b-button id="feedbackButton" class="mb-5" :disabled="openAnswer > 1000" @click="answerOpen(pendingQuestion.scaleIdentifier, pendingQuestion.identifier, openAnswer)">{{ $t('common:continue')}}</b-button>
                  </div>
                  <div v-if="openAnswer === null && answering[pendingQuestion.identifier] !== undefined">
                    <b-button v-if="answering[pendingQuestion.identifier]" class="active" disabled="true" variant="survey">{{ answering[pendingQuestion.identifier] }}</b-button>
                  </div>
                </div>
              </div>
            </transition>
          </b-col>
        </b-row>
      </div>

      <!-- SURVEY COMPLETE -->
      <transition name="question-slide">
        <b-row id="navigation-to-reports" align-v="center" align-h="center" v-if="showNavigationToReports && !accountOnboarding">
          <b-col cols="12" md="8" lg="6" >
            <div class="bubble--multiple-choice">
              <div class="message">
                {{$t('personal:all-answered__body', { userName: user.name })}}
              </div>{{$store.state.account.capabilities}}
              <!-- <ChallengeThemeSuggestion/> -->
              <ChallengeSuggestion/>
              <div class="choices">
                <b-button to="/personal/results">{{$t('personal:results-cta')}}</b-button>
                <b-button v-if="currentCompanyEngagementReport.updatedAt" to="/team/reports">{{$t('personal:team-results-cta')}}</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </transition>

      <b-row id="writing" align-v="center" align-h="center" v-if="writing">
          <b-col cols="12" md="8" lg="6" >
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import ChallengeThemeSuggestion from './coach/ChallengeThemeSuggestion'
import ChallengeSuggestion from './coach/ChallengeSuggestion'

const delayer = {
  maxdelay: 500,
  lastTimestamp: new Date().getTime(),
  reset: function () {
    this.lastTimestamp = new Date().getTime()
  },
  get: function () {
    const delta = new Date().getTime() - this.lastTimestamp
    return delta > this.maxdelay ? 0 : this.maxdelay - delta
  }
}

export default {
  components: {
    // ChallengeThemeSuggestion,
    ChallengeSuggestion
  },
  data () {
    return {
      questionIndex: 0,
      answering: {},
      answerFromLinkPending: false,
      answerFromLinkSuccess: false,
      currentLanguage: this.$i18n.i18next.language,
      currentEngagementReport: {},
      currentCompanyEngagementReport: {},
      writing: true,
      showHello: false,
      showRemaining: false,
      showX: false,
      showQuestions: false,
      showNavigationToReports: false,
      answerNowActive: false,
      skipOnboarding: false,
      skipValidation: false,
      openAnswer: null
    }
  },
  mounted () {
    this.$store.dispatch('loadPendingQuestions')

    // Start conversation
    this.writing = false
    this.showHello = true

    if (this.$route.query.s && this.$route.query.q && this.$route.query.a) {
      this.answerFromLinkPending = true
      this.axios.put('/scale/' + this.$route.query.s + '/' + this.$route.query.q, { answer: this.$route.query.a }).then(response => {
        this.$store.dispatch('loadPendingQuestions').then(() => {
          this.answerFromLinkPending = false
          this.answerFromLinkSuccess = true
        }).catch(() => {
          this.answerFromLinkPending = false
          this.answerFromLinkSuccess = false
        })
      }).catch(() => {
        this.answerFromLinkPending = false
      })
    }

    this.axios.get('/stats/user/current/engagement').then((response) => {
      this.currentEngagementReport = response.data
    })

    this.axios.get('/stats/current/engagement').then((response) => {
      this.currentCompanyEngagementReport = response.data
    })

    const self = this

    this.$i18n.i18next.on('languageChanged', function (lng) {
      self.$forceUpdate()
    })
  },
  watch: {
    pendingQuestionsLoading: {
      handler: function (val) {
        if (this.pendingQuestionsLoading === false) {
          setTimeout(() => {
            this.writing = true
            setTimeout(() => {
              this.writing = false
              this.showRemaining = true
            }, 1000)
          }, 500)

          if (this.numberOfPendingQuestions === 0) {
            this.writing = true
            setTimeout(() => {
              this.writing = false
              this.showNavigationToReports = true
              setTimeout(() => {
                this.$scrollTo(this.$el.querySelector('#navigation-to-reports'), 300, { offset: -0 })
              }, 500)
            }, 1000)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    startSurvey () {
      this.answerNowActive = true
      this.writing = true
      this.$nextTick(function () {
        this.$scrollTo(this.$el.querySelector('#writing'), 300, { offset: -0 })
      })
      setTimeout(() => {
        this.writing = false
        this.showQuestions = true
        setTimeout(() => {
          this.$scrollTo(this.$el.querySelector(`#q-${this.questionIndex}`), 300, { offset: -0 })
        }, 0)
      }, 500)
    },
    skipOnboardingWrite () {
      this.writing = true
      this.$nextTick(function () {
        this.$scrollTo(this.$el.querySelector('#writing'), 300, { offset: -0 })
      })
      setTimeout(() => {
        this.skipOnboarding = true
        this.writing = false

        this.$nextTick(function () {
          this.$scrollTo(this.$el.querySelector('#answerbutton'), 300, { offset: -0 })
        })
      }, 500)
    },
    answer (scaleId, questionId, answerValue) {
      this.answering[questionId] = answerValue

      // DRY-RUN
      // setTimeout(() => {
      //   // this.answering = null
      //   this.writing = true
      //   setTimeout(() => {
      //     this.$scrollTo(this.$el.querySelector('#writing'), 500, { offset: -0 })
      //     setTimeout(() => {
      //       this.writing = false
      //       this.questionIndex = this.questionIndex + 1
      //       setTimeout(() => {
      //         this.$scrollTo(this.$el.querySelector(`#q-${this.questionIndex}`), 500, { offset: -0 })
      //       }, 0)
      //     }, 1000 + Math.random() * 1000)
      //   }, 0)
      // }, 300)

      this.writing = true
      setTimeout(() => {
        this.$scrollTo(this.$el.querySelector('#writing'), 300, { offset: -0 })
      }, 0)

      delayer.reset()

      this.axios.put('/scale/' + scaleId + '/' + questionId, { answer: answerValue }).then(response => {
        // this.writing = true
        // setTimeout(() => {
        //   this.$scrollTo(this.$el.querySelector('#writing'), 500, { offset: -0 })
        // }, 0)

        if (this.numberOfPendingQuestions <= this.questionIndex + 1) {
          setTimeout(() => {
            this.writing = false
            this.showNavigationToReports = true
            setTimeout(() => {
              this.$scrollTo(this.$el.querySelector('#navigation-to-reports'), 300, { offset: -0 })
            }, 0)
          }, delayer.get())

          //  this.questionIndex = 0
          //  this.$router.push('/personal/results')
          //  this.$store.dispatch('loadPendingQuestions')
        } else {
          setTimeout(() => {
            this.writing = false
            this.questionIndex = this.questionIndex + 1
            setTimeout(() => {
              this.$scrollTo(this.$el.querySelector(`#q-${this.questionIndex}`), 300, { offset: -0 })
            }, 0)
          }, delayer.get())
        }
      }).catch(() => {
        this.answering = null
      })
    },
    answerOpen (scaleId, questionId, answerValue) {
      this.answering[questionId] = answerValue

      this.writing = true
      setTimeout(() => {
        this.$scrollTo(this.$el.querySelector('#writing'), 300, { offset: -0 })
      }, 0)

      delayer.reset()

      this.axios.put('/scale/open/' + scaleId + '/' + questionId, { answer: answerValue.trim() }).then(response => {
        this.openAnswer = null
        if (this.numberOfPendingQuestions <= this.questionIndex + 1) {
          setTimeout(() => {
            this.writing = false
            this.showNavigationToReports = true
            setTimeout(() => {
              this.$scrollTo(this.$el.querySelector('#navigation-to-reports'), 300, { offset: -0 })
            }, 0)
          }, delayer.get())
        } else {
          setTimeout(() => {
            this.writing = false
            this.questionIndex = this.questionIndex + 1
            setTimeout(() => {
              this.$scrollTo(this.$el.querySelector(`#q-${this.questionIndex}`), 300, { offset: -0 })
            }, 0)
          }, delayer.get())
        }
      }).catch(() => {
        this.answering = null
      })
    },
    renderOpener (pendingQuestion) {
      if (!pendingQuestion.opener || !pendingQuestion.opener[this.$i18n.i18next.language]) {
        return null
      }
      return pendingQuestion.opener[this.$i18n.i18next.language].replace('{{accountName}}', this.$store.state.account.name)
    },
    renderQuesstion (pendingQuestion) {
      return pendingQuestion.question[this.$i18n.i18next.language].replace('{{accountName}}', this.$store.state.account.name)
    },
    i18nLabel (option) {
      return option.label[this.$i18n.i18next.language]
    },
    sortedOptions (pendingQuestion) {
      return pendingQuestion.options.slice(0).sort((a, b) => { return a.index > b.index ? 1 : (b.index > a.index ? -1 : 0) })
    }
  },
  computed: {
    ...mapGetters(['pendingQuestionsLoading', 'numberOfPendingQuestions', 'isOwner', 'user']),
    showValidationPrompt () {
      return this.$store.state.preloadSuccess && !this.user.validated
    },
    showInvitationPrompt () {
      return this.user.validated && this.isOwner && this.$store.state.account.users.length < 5
    },
    accountOnboarding () {
      return !this.skipOnboarding && this.showInvitationPrompt
    },
    pendingQuestionsUpToIndex () {
      // index <= questionIndex
      return this.$store.state.pendingQuestions.slice(0, this.questionIndex + 1)
    }
  }
}
</script>

<style lang="scss">

  #survey-subview {
    margin-top: 1rem;
    @media (min-width: 575px) {
      margin-top: 1rem;
    }
    @media (min-width: 900px) {
      margin-top: 2rem;
    }
  }

  $primary: #377771; //#20a8cc;

  .panel-light--survey {
    padding: 0 1rem 1rem 1rem;
    margin: auto;
    background: rgba(white, 0.9);
    color: black;

    @media (min-width: 575px) {
      // margin: 0rem auto;
      padding: 0 0 2rem 0;
    }

    text-align: center;
    // position: absolute;
    // width: calc(100% - 2rem);

    h3 {
      font-size: 1.25rem;
      padding: 1rem 0 0 0;
      margin: 0;
//      padding: 2rem 1rem 1rem 1rem;
      @media (min-width: 900px) {
        padding-top: 2rem;
        font-size: 1.75rem;
      }
    }

    .opener {
      background: rgba($primary, 0.75);
      padding: 1rem;
    }
  }

  .question-slide-enter {
    pointer-events: none;
    opacity: 0;
    transform: scale(0.9);
    position: absolute;
    .choices {
      opacity: 1;
      // transform: scale(0.9);
    }
  }
  .question-slide-enter-active {
    pointer-events: none;
    opacity: 0;
  }
  .question-slide-enter-to {
    transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275) 50ms;
    pointer-events: none;
    opacity: 1;
    transform: scale(1);
//    width: calc(100%);
//    position: relative;
    .choices {
      transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275) 1350ms;
      opacity: 1;
      transform: scale(1);
    }

  }

  .question-slide-leave {
    transition: all 0.5s ease-in-out;
    pointer-events: none;
    opacity: 1;
    transform: translateY(0);
//    position: absolute;
//    width: calc(100%);
//    position: relative;
  }
  .question-slide-leave-active {
    pointer-events: none;
    transition: all 0.5s ease-in-out;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
//    width: calc(100%);
//    top: 0;
//    position: absolute;
  }
  .question-slide-leave-to {
    transition: all 0.5s ease-in-out;
    pointer-events: none;
    opacity: 0;
    transform: translateY(-50%);
//    width: calc(100%);
//    position: absolute;
  }

$multiple_choice__gutter: 0.25rem;
.multiple-choice {
    opacity: 1;
    width: 100%;
    position: relative;
    margin: 1.5rem 0 0 0;

    @media (min-width: 992px) {
      margin: 2rem 0;
    }

    button {

      transition: opacity 0.25s ease-in 0.0s, transform 0.15s ease-in-out;
      &:nth-child(1) {
        transition: opacity 0.25s ease-in 0.10s, transform 0.15s ease-in-out;
      }
      &:nth-child(2) {
        transition: opacity 0.25s ease-in 0.15s, transform 0.15s ease-in-out;
      }
      &:nth-child(3) {
        transition: opacity 0.25s ease-in 0.20s, transform 0.15s ease-in-out;
      }
      &:nth-child(4) {
        transition: opacity 0.25s ease-in 0.25s, transform 0.15s ease-in-out;
      }
      &:nth-child(5) {
        transition: opacity 0.25s ease-in 0.30s, transform 0.15s ease-in-out;
      }
      &:nth-child(6) {
        transition: opacity 0.25s ease-in 0.35s, transform 0.15s ease-in-out;
      }
      &:nth-child(7) {
        transition: opacity 0.25s ease-in 0.40s, transform 0.15s ease-in-out;
      }

        // @extend .button;
        display: inline-block;
        text-align: center;
        vertical-align: top;
        line-height: 1.2em;
        position: relative;
        background: white; // $primary;
        color: darken($primary, 25%); // white;
        border-color: white; //lighten($primary, 40%);
        padding: 0.5em;
        font-weight: normal;
        white-space: normal;
//        text-shadow: 0 1px 2px rgba(black, 0.2);
        box-shadow: 0 0.2rem 0.35rem rgba(black, 0.1);

        &:hover:not([disabled]), &.active:not([disabled]) {
//          background-color: tint(#ecbf10, 10%) !important;
//          background: darken($primary, 5%) !important;
//          background: tint($primary, 60%);
          // border-color: white !important;
          box-shadow: 0 0.1rem 0.2rem rgba(black,0.2) !important;
          transform: scale(1.05);
        }

        &.active, &.active:hover {
//        transition: padding 0.2s ease-in-out;
          transition: none;
          background-color: tint($primary, 20%) !important;
          border-color: white !important;
          opacity: 1.0;
          transform: scale(1.05);
          // cursor: wait!important;
        }

        width: 100%;
        height: auto;
        margin: 0 auto $multiple_choice__gutter*2 auto;
        max-width: 25em;
        display: block;
        // @media screen and (min-width: $size-small) {
        //   width: 100%;
        //   height: 3em;
        // }
        // @media screen and (min-width: $size-medium) {
        //   width: 100%;
        //   height: 3em;
        // }
        @media (min-width: 992px) {
            display: inline-block;
            width: calc(100% / 7 - #{$multiple_choice__gutter*4});
            height: 4.5em;
            margin: 0 $multiple_choice__gutter;
        }
        // @media screen and (min-width: $size-huge) {
        //     width: calc(100% / 7 - #{$multiple_choice__gutter*5});
        //     height: 5em;
        //     margin: 0 $multiple_choice__gutter;
        // }

        &:disabled:not(.active), &:hover:disabled:not(.active), &:active:disabled {
          pointer-events: none;
          transition: none;
          transition: none;
          // border-color: $primary !important;
          // background: $primary !important;
          opacity: 0.7;
          box-shadow: none;
          // cursor: none !important;
          // cursor: wait!important;
          // cursor: pointer !important;
          &.loading {
            opacity: 0.75 !important;
            border-color: white !important;
          }
        }
    }
}

// CONVERSATIONAL UI ELEMENTS

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 48px;
  margin-left: 12px;
}
.lds-ellipsis div {
  position: absolute;
  top: 19px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 500ms infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 500ms infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 500ms infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 500ms infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

</style>
